import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const SpeechBubbleFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function SpeechBubbleFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="M1 10.5v11h2l3-3h9c4.42 0 8-3.58 8-8s-3.58-8-8-8H9c-4.42 0-8 3.58-8 8Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default SpeechBubbleFilled;